import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { CertificateData } from '../../../typings';

export function getCertificatesMentor(): Promise<CertificateData[]> {
    const { apiGetCertificatesMentor } = apiConfig.getStaticUrls();

    return getFetch(apiGetCertificatesMentor);
}
